<div class="flex flex-col h-full gap-2 transition-all duration-300 py-4 bg-white bg-blend-darken overflow-x-hidden"
    [ngClass]="collapsed && isDesktop ? 'w-20' : 'w-72'">
    @if (isDesktop) {
        <div 
            class="item flex gap-4 px-5 items-center text-mg-main-blue-darkjustify-between">
            @if(!collapsed){
                <div class="flex items-center gap-3 hover:text-mg-accent-dark">
                    <mg-icon iconName="menu"></mg-icon>
                    <span class="text-[1rem] capitalize whitespace-nowrap">Menú</span>
                </div>
            }
            <div>
                <mg-icon *ngIf="!collapsed" iconName="side_navigation" class="hover:text-mg-accent-dark cursor-pointer" (click)="onToggleSidenav()"></mg-icon>
                <mg-icon *ngIf="collapsed" iconName="side_navigation" class="hover:text-mg-accent-dark cursor-pointer rotate-180" (click)="onToggleSidenav()"></mg-icon>
            </div>
        </div>
    }
    <div class="w-full h-full overflow-x-hidden overflow-y-auto">
        <mg-sidenav-item *ngFor="let item of items;" [item]="item" [level]="0" [isCollapsed]="collapsed"
            [isDesktop]="isDesktop" (clickItem)="clickItemAction($event)" (clickItem2)="clickItemAction($event)"></mg-sidenav-item>
    </div>
    <div class="h-[1px] bg-mg-gray m-3 rounded-full"></div>
    <div class="h-fit w-full flex justify-center items-center flex-col">
        <!-- <div #menuTriggerNotifications="matMenuTrigger" [matMenuTriggerFor]="notifications" *ngIf="isDesktop"
            class="cursor-pointer flex gap-4 px-5 py-3 items-center" [matTooltip]="isDesktop ? 'Notificaciones' : ''"
            matTooltipPosition="right">
            <div [matBadgeHidden]="counterNotifications <= 0"
                [matBadge]="counterNotifications >= 100 ? '99+' : counterNotifications" matBadgeColor="warn">
                <mg-icon iconClass="text-mg-green" iconName="notifications"></mg-icon>
            </div>
        </div> -->
        <div (click)="logout()" 
            class="item w-fit px-4 cursor-pointer flex gap-4 justify-center py-3 items-center hover:text-mg-accent-dark text-mg-main-blue-darkborder rounded-2xl border-mg-main-blue-redark"
            [matTooltip]="isDesktop ? 'Cerrar sesión' : ''" matTooltipPosition="right">
            <mg-icon iconName="logout"></mg-icon>
            <span *ngIf="!isDesktop || !collapsed" class="text-[0.9rem] capitalize whitespace-nowrap">Cerrar sesión</span>
        </div>
        <div class="flex gap-4 px-5 py-3 items-center">
            <!-- <span *ngIf="isDesktop && collapsed" class="text-[0.9rem] whitespace-nowrap text-mg-accent font-semibold" translate="no">v{{env.version}}</span> -->
            <!-- <span *ngIf="!isDesktop || !collapsed"  class="text-[0.9rem] whitespace-nowrap text-mg-accent font-semibold">©2025 SMART • Versión {{env.version}}</span> -->
        </div>
    </div>
</div>

<mat-menu #notifications="matMenu"
    class="!rounded-2xl !max-w-full !w-[40rem] !h-[55rem] !max-h-screen !overflow-hidden" xPosition="before">
    <div class="max-w-full w-[40rem] h-[55rem] max-h-screen overflow-y-auto" (click)="$event.stopPropagation();">
        <!-- <mg-notifications-pop-up (badgeCounter)="badgeCounterNotifications($event)" [matMenu]="menuTriggerNotifications"
           ></mg-notifications-pop-up> -->
    </div>
</mat-menu>
